export default "/images/ba927f0a054695aa616a21e479eafa92.avif";